import React from 'react';
import TablaRentasInmobiliarias from '../components/rentas/tablaRentas';


function RengasInmo() {
  return (
      <div className='col-12 d-flex justify-content-center row p-0 m-0'>
        <TablaRentasInmobiliarias />
      </div>
  );
}

export default RengasInmo;




// WEBPACK FOOTER //
// ./src/pages/rentainmibiliaria.js